var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_5764)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.3721,
    cy: 17,
    r: 17,
    fill: "#7E90EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0204 24.7276C24.3583 24.7276 21.3038 23.5804 18.047 20.3184C16.2501 18.5189 14.8576 16.4944 14.1164 14.6271C13.4876 12.9174 13.4876 11.5226 14.1164 10.8927C14.1838 10.8253 14.2288 10.7802 14.2961 10.7128C14.4085 10.5778 14.5432 10.4203 14.678 10.2853C15.1721 9.7904 15.7336 9.27304 16.4522 9.27304C17.0811 9.27304 17.6876 9.63301 18.3165 10.4203C20.0684 12.6024 19.3048 13.3672 18.3614 14.312L18.2041 14.4695C18.0468 14.6271 17.7999 15.3018 20.4277 17.9338C22.337 19.846 23.2129 20.2058 23.6395 20.2058C23.7518 20.2058 23.8416 20.1607 23.909 20.0933L24.0663 19.9357C24.5828 19.4184 25.0546 18.9459 25.7732 18.9459C26.3347 18.9459 27.0759 19.2608 27.9519 19.9808C28.6707 20.6106 29.0299 21.173 29.0973 21.7354C29.1423 22.6127 28.4235 23.2877 27.7946 23.85C27.6823 23.9626 27.5925 24.0525 27.4802 24.1199C27.1659 24.5701 26.6493 24.7275 26.0205 24.7275L26.0204 24.7276Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_5764",
    x: 0.37207,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_5764"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_5764",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallButton);
export default __webpack_public_path__ + "static/media/CallButton.d48c50ce15db53d08b60a7846e70242b.svg";
export { ForwardRef as ReactComponent };